import axios, { AxiosResponse } from "axios"
import { ConciliarMovimientosCommandProps } from "./Commands/ConciliarMovimientosCommand"
import { InsertConciliacionBancariaCommandProps } from "./Commands/InsertConciliacionBancariaCommand"
import { getConciliacionBancariaIdAdapter } from "./ConciliacionBancaria.adapter"
import { GetConciliacionBancariaByIdDtoProps } from "./DTOs/GetConciliacionBancariaByIdDto"

export async function postConciliacionBancaria(
  queryParams: ConciliarMovimientosCommandProps
): Promise<AxiosResponse> {
  const response = await axios.post(
    "/ConciliacionBancaria/conciliar",
    queryParams
  )
  return response
}

export async function postConciliacionBancariaManual(
  requestBody: InsertConciliacionBancariaCommandProps
): Promise<AxiosResponse> {
  const response = await axios.post("/ConciliacionBancaria/", requestBody)
  return response
}

export async function putForzarConciliacionBancaria(
  conciliaciones: string[]
): Promise<void> {
  await axios.put("/ConciliacionBancaria/forzar", {
    conciliacionIds: conciliaciones,
  })
}

export async function putRestaurarConciliacionBancaria(
  conciliaciones: string[]
): Promise<void> {
  await axios.put("/ConciliacionBancaria/restaurar", {
    conciliacionIds: conciliaciones,
  })
}

export async function getConciliacionBancariaById(
  id: string
): Promise<GetConciliacionBancariaByIdDtoProps> {
  const { data } = await axios.get(`ConciliacionBancaria/${id}`)

  return getConciliacionBancariaIdAdapter(data)
}

export async function deleteConciliacionBancariaById(
  id: string
): Promise<AxiosResponse> {
  const resp = await axios.delete(`ConciliacionBancaria/${id}`)
  return resp
}
